import angular from 'angular'
import 'angular-route'
import 'angular-resource'

// Cross-cutting styling
import 'normalize.css/normalize.css'
import '../style/style.scss'

// Tech debts that can't be cleaned easily, manual vendor folder instead of npm dependency
// Inject at the root for easier tracking
// Vendor - UI Select
import '../../vendor/ui-select/select'
// Vendor - Date picker
import '../../vendor/datepicker/directive'
// Vendor - Tracking
import '../../vendor/tracking'

// Core - Controllers, modules and pages
import '../../core/main/controller/environment.js'
import '../../core/main/controller/controller.js'
import '../../core/main/module/controller.js'

import 'angular-sanitize'
import i18next from 'i18next'
import 'ng-i18next'
import i18nextOptions from './i18nextConfig'

angular.module('merchant.application.main', [
  'ui.select',
  'ngRoute',
  'jm.i18next',
  'ngResource',
  'core.application.main',
  'core.application.module',
  'merchant.application.module.languageSelector',
  'core.application.module.modal',
  'core.application.module.headerMinor',
  'core.application.module.headerPage',
  'merchant.application.module',
  'merchant.application.module.footer',
  'merchant.application.module.header',
  'merchant.application.page',
  'merchant.application.page.inStore',
  'merchant.application.page.login',
  'merchant.application.page.logout',
  'merchant.application.page.okta',
  'merchant.application.page.resetAsk',
  'merchant.application.page.resetConfirm',
  'merchant.application.page.settlement.settlements',
  'merchant.application.page.settlement.cardReconciliations',
  'merchant.application.page.settlement.onlineCardReconciliations',
  'merchant.application.page.settlement.settlementDetail',
  'merchant.application.page.settlement.cardReconciliationDetail',
  'merchant.application.page.settlement.onlineCardReconciliationDetail',
  'merchant.application.page.settlement.settlementSummary',
  'merchant.application.page.settlement.cardReconciliationSummary',
  'merchant.application.page.settlement.onlineCardReconciliationSummary',
  'merchant.application.page.merchantAdmin.main',
  'merchant.application.page.merchantAdmin.shopConfiguration',
  'merchant.application.page.order.detail',
  'merchant.application.page.order.orders',
  'merchant.application.page.inStore.barcode',
  'merchant.application.page.inStore.card',
  'merchant.application.page.inStore.card.acquirerDetails',
  'merchant.application.page.inStore.card.invoicingEmails'
]).controller('merchant.application.main.controller', [
  '$rootScope', '$scope', '$http', '$window', '$timeout',
  'core.application.main.factory.feature',
  'core.application.main.factory.analytics',
  'core.application.main.controller.environment',
  function ($rootScope, $scope, $http, $window, $timeout, Feature, Analytics, Environment) {
    $scope.loadingFeatureFlags = true
    $scope.featureFlagsWaitTime = 4000 // how long to wait for the flags in milliseconds

    $scope.$on('featureFlagsReady', function () {
      $scope.loadingFeatureFlags = false
    })

    $scope.brandName = Environment.BRAND_NAME
    $scope.googleMapsApiKey = Environment.GOOGLEMAPS_API_KEY
    $scope.isLoading = function () {
      const requestsForLoading = $http.pendingRequests.filter((r) => !r.excludeFromLoading)
      return requestsForLoading.length > 0 || $scope.loadingFeatureFlags
    }

    i18next.init(i18nextOptions)
  }
])
require('../../module/header/controller.js')

// Merchant - Root Module
require('../../module/controller.js')
// Merchant - Root Page
require('../../page/controller.js')

require('./router.js')
